'use client';

import { FeatureFlagEnum, FeatureToggle } from '@shared/featureManagment';
import { SidebarLayout } from '@widgets/sidebar-layout';
import { NotFound } from '@shared/ui';
import { Setting2 } from 'iconsax-react';
import { language, managementSidebarLinks } from '../model';

export const ManagementLayout = ({ children }: { children: React.ReactNode }) => {
  return (
    <FeatureToggle flag={FeatureFlagEnum.managementEnabled} fallback={<NotFound />}>
      <SidebarLayout
        title={language.management}
        sidebarLinks={managementSidebarLinks}
        sidebarIcon={
          <div className='flex h-[100px] w-[100px] items-center justify-center rounded-full bg-hover my-[40px]'>
            <Setting2 size={48} className='text-blue-1' />
          </div>
        }
      >
        {children}
      </SidebarLayout>
    </FeatureToggle>
  );
};
